<div class="sidenavContainer">
  <!-- TODO: acomodar al menu segun corresponda-->
  <mat-nav-list>
    <div *ngFor="let item of menuItems">
      <a mat-list-item class="item-list" (click)="onSidenavToggle()" [routerLink]="item.url">{{item.name}}</a>
    </div>
  </mat-nav-list>
</div>
